import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { StyledBoxProps } from './types';

const StyledContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isPrint',
})<StyledBoxProps>(({ isPrint }) => ({
  marginTop: 24,
  ...(isPrint && {
    border: `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,
    paddingLeft: 0,
    paddingRight: 0,
    borderRadius: '8px',
    marginBottom: '40px',
  }),
}));

export { StyledContainer };
